import type { AiAssistantEmployee } from '../services/aiAssistantService';
import {
  listEmployeeGradingOverrides,
  listPositionGradings,
} from '../services/localEmployeeGradingStore';
import { listLocalEmployees, type LocalEmployee } from '../services/localEmployeesStore';
import { resolveEmployeeGrading } from './employeeMarketComparisonUtils';

export function enrichEmployeeForAiAssistant(
  employee: LocalEmployee,
  positionGradings: Awaited<ReturnType<typeof listPositionGradings>>,
  employeeOverrides: Awaited<ReturnType<typeof listEmployeeGradingOverrides>>,
): AiAssistantEmployee {
  const grading = resolveEmployeeGrading(employee, positionGradings, employeeOverrides);

  return {
    id: employee.id,
    fullName: employee.fullName,
    position: employee.position,
    fixMonthlyGross: employee.fixMonthlyGross,
    fixAnnualGross: Math.round(employee.fixMonthlyGross * 12),
    stiFraction: employee.stiFraction,
    ltip: employee.ltip,
    grading: grading
      ? {
          familyName: grading.familyName,
          gradeLevel: grading.gradeLevel,
          roleName: grading.roleName,
          source: grading.source,
        }
      : null,
  };
}

export async function buildAiAssistantEmployees(): Promise<AiAssistantEmployee[]> {
  const [employees, positionGradings, employeeOverrides] = await Promise.all([
    listLocalEmployees(),
    listPositionGradings(),
    listEmployeeGradingOverrides(),
  ]);

  return employees.map((employee) =>
    enrichEmployeeForAiAssistant(employee, positionGradings, employeeOverrides),
  );
}
